import { render } from "./UnsubscribeDialog.vue?vue&type=template&id=b5fd11b8&scoped=true"
import script from "./UnsubscribeDialog.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeDialog.vue?vue&type=script&lang=ts"

import "./UnsubscribeDialog.vue?vue&type=style&index=0&id=b5fd11b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5fd11b8"

export default script